import React from "react";

export default function DeleteAccount() {
  const language = navigator.language.slice(0, 2); // ex: "pt", "en", "es"

  const content = {
    pt: {
      title: "Excluir conta – Kito",
      intro: "Você pode excluir sua conta diretamente no app Kito.",
      howTo: "Como excluir sua conta:",
      steps: [
        "Abra o aplicativo Kito.",
        "Acesse o menu de Configurações.",
        "Selecione “Excluir Conta” e confirme.",
      ],
      whatHappens: "O que acontece ao excluir sua conta:",
      effects: [
        "Seu e-mail, nome e histórico de leitura serão excluídos permanentemente.",
        "Preferências e favoritos serão apagados.",
        "Não armazenamos dados pessoais após a exclusão.",
        "Dados anônimos podem ser mantidos por até 30 dias para fins de segurança e estatísticas.",
      ],
      help: "Precisa de ajuda?",
      contact: "Fale com a gente: contato@kito.app.br",
    },
    en: {
      title: "Delete your Kito account",
      intro: "You can delete your Kito account directly in the app.",
      howTo: "How to delete your account:",
      steps: [
        "Open the Kito app.",
        "Go to the Settings menu.",
        "Select “Delete Account” and confirm.",
      ],
      whatHappens: "What happens when you delete your account:",
      effects: [
        "Your email, name, and reading history will be permanently deleted.",
        "Your preferences and favorites will be erased.",
        "We do not store personal data after deletion.",
        "Anonymous usage data may be retained for up to 30 days for security and analytics purposes.",
      ],
      help: "Need help?",
      contact: "Contact us: contato@kito.app.br",
    },
    es: {
      title: "Eliminar tu cuenta de Kito",
      intro: "Puedes eliminar tu cuenta directamente desde la app de Kito.",
      howTo: "Cómo eliminar tu cuenta:",
      steps: [
        "Abre la aplicación Kito.",
        "Ve al menú de Configuraciones.",
        "Selecciona “Eliminar cuenta” y confirma.",
      ],
      whatHappens: "¿Qué sucede al eliminar tu cuenta?",
      effects: [
        "Tu correo electrónico, nombre e historial de lectura se eliminarán permanentemente.",
        "Tus preferencias y favoritos serán borrados.",
        "No almacenamos datos personales después de la eliminación.",
        "Los datos anónimos pueden mantenerse hasta por 30 días con fines de seguridad y análisis.",
      ],
      help: "¿Necesitas ayuda?",
      contact: "Escríbenos: contato@kito.app.br",
    },
  };

  const t = content[language] || content.pt; // fallback para PT

  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", color: "#333" }}>
      <h1>{t.title}</h1>
      <p>{t.intro}</p>

      <h2>{t.howTo}</h2>
      <ol>
        {t.steps.map((step, index) => (
          <li key={index}>{step}</li>
        ))}
      </ol>

      <h2>{t.whatHappens}</h2>
      <ul>
        {t.effects.map((effect, index) => (
          <li key={index}>{effect}</li>
        ))}
      </ul>

      <p>
        <strong>{t.help}</strong> <br />
        {t.contact.includes("@") ? (
          <a href="mailto:contato@kito.app.br">{t.contact}</a>
        ) : (
          t.contact
        )}
      </p>
    </div>
  );
}
